import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Mode = 'light' | 'dark';
export type Direction = 'ltr' | 'rtl';
export type NavMode = 'transparent' | 'light' | 'dark' | 'themed';
export type ControlSize = 'sm' | 'md' | 'lg';

export interface ThemeState {
  mode: Mode;
  direction: Direction;
  primaryColorLevel: number;
  navMode: NavMode;
  controlSize: ControlSize;
}

const initialState: ThemeState = {
  mode: 'light',
  direction: 'ltr',
  primaryColorLevel: 600,
  navMode: 'light',
  controlSize: 'md',
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setMode: (state, action: PayloadAction<Mode>) => {
      state.mode = action.payload;
    },
    setDirection: (state, action: PayloadAction<Direction>) => {
      state.direction = action.payload;
    },
    setPrimaryColorLevel: (state, action: PayloadAction<number>) => {
      state.primaryColorLevel = action.payload;
    },
    setNavMode: (state, action: PayloadAction<NavMode>) => {
      state.navMode = action.payload;
    },
    setControlSize: (state, action: PayloadAction<ControlSize>) => {
      state.controlSize = action.payload;
    },
  },
});

export const {
  setMode,
  setDirection,
  setPrimaryColorLevel,
  setNavMode,
  setControlSize,
} = themeSlice.actions;

export default themeSlice.reducer; 